"use strict";
/* globals module */
/**
 * @module calendarRsvpAttendeeClient
 * @description  CalendarRsvpAttendeeClient provides an easy way to consume CalendarRsvpAttendee REST API end-points. In order to obtain needed routes `calendarRsvpAttendeeClient` uses `calendarRsvpAttendeeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarRsvpAttendeeClient = /** @class */ (function () {
    function CalendarRsvpAttendeeClient(calendarRsvpAttendeeBatchClient, calendarRsvpAttendeeRoute, apiClient) {
        this.calendarRsvpAttendeeBatchClient = calendarRsvpAttendeeBatchClient;
        this.calendarRsvpAttendeeRoute = calendarRsvpAttendeeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpAttendeeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpAttendeeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarRsvpAttendeeClient.prototype, "batch", {
        get: function () {
            return this.calendarRsvpAttendeeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventAttendee resources matching the given criteria.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetCalendarLookupOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarRsvpAttendeeClient.find(calendarId, eventId, {
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: '<ids>',
                    userIds: '<user-ids>',
                    emails: '<emails>',
                    fullNames: '<full-names>',
                    invitationTypeIds: '<invitation-type-ids>',
                    from: <from-date>,
                    to: <to-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.find = function (calendarId, eventId, options) {
        return this.apiClient.get(this.routeDefinition.find(calendarId, eventId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventAttendee resource.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarRsvpAttendeeClient.get(calendarId,eventId, id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.get = function (calendarId, eventId, id, options) {
        return this.apiClient.get(this.routeDefinition.get(calendarId, eventId, id, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventAttendee resource.
     * @method
     * @param calendarId Calendar Id which uniquely identifies a Calendar resource.
     * @param eventId CalendarEvent Id which uniquely identifies a calendarEvent resource
     * @param emailOrFullName Email or full name which identify a CalendarEventRsvpAttendee resource.
     * @param options Query resource options object.
     * @example calendarRsvpAttendeeRoute.getByEmailOrFullName(calendarId, eventId, fullname);
     */
    CalendarRsvpAttendeeClient.prototype.getByEmailOrFullName = function (calendarId, eventId, emailOrFullName, options) {
        return this.apiClient.get(this.routeDefinition.getByEmailOrFullName(calendarId, eventId, emailOrFullName, options));
    };
    /**
     * Returns a promise that is resolved once the link CalendarEventAttendee action has been performed; this action links a new CalendarEventAttendee resource to a specified calendarEvent.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @returns A promise that is resolved once the link CalendarEventAttendee action has been performed.
     * @example calendarRsvpAttendeeClient.link(calendarId, eventId, {
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.link = function (calendarId, eventId, data) {
        return this.apiClient.post(this.routeDefinition.link(eventId, calendarId, data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarEventAttendee.name = '<name>';
                calendarRsvpAttendeeClient.update(calendarEventAttendee)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.update = function (calendarId, eventId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, eventId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarRsvpAttendeeClient.updateStatus(calendarid, eventid, id, statusid)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.updateStatus = function (calendarId, eventId, id, statusId) {
        return this.apiClient.put(this.routeDefinition.updateStatus(calendarId, eventId, id, statusId), {});
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status action has been performed. This action updates a CalendarEventAttendee resource.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniqely identifies CalendarEvent resource.
     * @param emailOrFullName Email or FullName.
     * @param securityToken Security token.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeClient.update(calendarId, eventId, email, statusId);
     */
    CalendarRsvpAttendeeClient.prototype.updateStatusEmailOrFullName = function (calendarId, eventId, emailOrFullName, securityToken, statusId) {
        var headers;
        headers['securityToken'] = securityToken;
        return this.apiClient.put(this.routeDefinition.updateStatusEmailOrFullName(calendarId, eventId, emailOrFullName, statusId), {}, headers);
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink a CalendarEventAttendee resource from the CalendarEvent if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventAttendee object used to delete specified CalendarEventAttendee resource.
     * @param eventId CalendarEvent id which uniquely identifies CaledndarEvent resource.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarRsvpAttendeeClient.unlink(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unlink = function (calendarId, eventId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, eventId, data));
    };
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action creates CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example calendarRsvpattendeeClient.subscribe(calendarId, eventId, attendeeId)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.subscribe = function (calendarId, eventId, id) {
        return this.apiClient.post(this.routeDefinition.subscribe(eventId, calendarId, id), {});
    };
    /**
     * Returns a promise that is resolved once the unsubscribe action has been performed. This action removes CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example calendarRsvpattendeeClient.unsubscribe(calendarId, eventId, attendeeId)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unsubscribe = function (calendarId, eventId, id) {
        return this.apiClient.delete(this.routeDefinition.unsubscribe(eventId, calendarId, id));
    };
    /**
     * Returns a promise that is resolved once the subscribeEmail action has been performed. This action creates CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribeEmail action has been performed.
     * @example calendarRsvpattendeeClient.subscribeEmail(calendarId, eventId, attendeeEmail)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.subscribeEmail = function (calendarId, eventId, email) {
        return this.apiClient.post(this.routeDefinition.subscribeEmail(eventId, calendarId, email), {});
    };
    /**
     * Returns a promise that is resolved once the unsubscribeEmail action has been performed. This action removes CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribeEmail action has been performed.
     * @example calendarRsvpattendeeClient.unsubscribeEmail(calendarId, eventId, attendeeEmail)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unsubscribeEmail = function (calendarId, eventId, id) {
        return this.apiClient.delete(this.routeDefinition.unsubscribe(eventId, calendarId, id));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventAttendee resources for the given event from the system if succesfully completed.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource that will have it's attendees purged.
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarRsvpAttendeeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.purge = function (calendarId, eventId) {
        return this.apiClient.delete(this.routeDefinition.purge(calendarId, eventId));
    };
    var _a, _b, _c;
    CalendarRsvpAttendeeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpAttendeeBatchClient !== "undefined" && __1.CalendarRsvpAttendeeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarRsvpAttendeeRoute !== "undefined" && __1.CalendarRsvpAttendeeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarRsvpAttendeeClient);
    return CalendarRsvpAttendeeClient;
}());
exports.CalendarRsvpAttendeeClient = CalendarRsvpAttendeeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
